// extracted by mini-css-extract-plugin
module.exports = {"cookie":"Cookies_cookie__V_n71","block":"Cookies_block__Muo9t","btn":"Cookies_btn__aKpGP"};